import {TemplateReference} from "@cm/template-nodes"
import {createMattressComponentInstance} from "#mattress/assets-definitions/create-mattress"
import {createTemplateReference} from "#mattress/assets-definitions/common"
import {MattressComponentInstance} from "#mattress/nodes/component/mattress-component-instance"
import {MattressMesh} from "#mattress/nodes/mattress-mesh"
import type {Mattress} from "#mattress/nodes/mattress"

export const PLANE_OVERLAY_INSTANCE_ID = "plane-overlay"

// The overlay template sizes its planes from width/length/height, so these are wired to the same sources as the root mattress mesh.
export function insertPlaneOverlay(mattress: Mattress, planeOverlayTemplateLegacyId: number): void {
    const nodes = mattress.parameters.root.parameters.nodes
    if (nodes.parameters.list.some((node) => isPlaneOverlayInstance(node, planeOverlayTemplateLegacyId))) return

    const mattressMesh = nodes.parameters.list.find((node) => node instanceof MattressMesh)
    if (!mattressMesh) throw new Error("The mattress root has no mattress mesh to take the plane overlay dimensions from.")
    const {width, length, height} = mattressMesh.parameters.geometry

    nodes.addEntry(
        createMattressComponentInstance("Plane Overlay", PLANE_OVERLAY_INSTANCE_ID, createTemplateReference(planeOverlayTemplateLegacyId), {
            width,
            length,
            height,
        }),
    )
}

export function removePlaneOverlay(mattress: Mattress, planeOverlayTemplateLegacyId: number): void {
    const nodes = mattress.parameters.root.parameters.nodes
    for (const node of nodes.parameters.list.filter((node) => isPlaneOverlayInstance(node, planeOverlayTemplateLegacyId))) nodes.removeEntry(node)
}

// Also matches overlays wired up by hand under a different instance id.
function isPlaneOverlayInstance(node: unknown, planeOverlayTemplateLegacyId: number): node is MattressComponentInstance {
    if (!(node instanceof MattressComponentInstance)) return false
    if (node.parameters.id === PLANE_OVERLAY_INSTANCE_ID) return true
    const graph = node.parameters.graph
    return graph instanceof TemplateReference && graph.parameters.templateId === planeOverlayTemplateLegacyId
}
